import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { Button } from '../../../../subcomponents/button/button';
import { ButtonColor } from '../../../../subcomponents/button/types/color';
import { Icon } from '../../../../subcomponents/icon';
import { MemberPhoto } from '../../photo/member-photo';
import { MemberPhotoUploaderContextInstance } from '../types/context';
const b = bemClassBuilder('v-member-photo-uploader-photo');
export const MemberPhotoUploaderPhoto = observer(props => {
    const { member, onUpdatePhotoClick } = props;
    const { displayText, assets } = useContext(MemberPhotoUploaderContextInstance);
    if (!member.photo)
        return null;
    const { isUpdatable } = member.photo;
    return (_jsxs("div", Object.assign({ className: b.block() }, { children: [_jsxs("div", Object.assign({ className: b.element('photo') }, { children: [!isUpdatable && (_jsx("div", Object.assign({ className: b.element('lock-icon-wrapper') }, { children: _jsx(Icon, { className: b.element('lock-icon'), name: assets.lockedMemberPhotoIconName }) }))), _jsx(MemberPhoto, {})] })), isUpdatable && (_jsx(Button, { iconName: assets.updatePhotoButtonIconName, label: displayText.updatePhotoButtonLabel, color: ButtonColor.Secondary, className: b.element('update-photo-button'), onClick: onUpdatePhotoClick }))] })));
});
MemberPhotoUploaderPhoto.displayName = 'MemberPhotoUploaderPhoto';
